import { createFileRoute } from "@tanstack/react-router";

import PaymentDetail from "@/pages/payment/PaymentDetail";

function PaymentDetailPage() {
  const { caseId } = Route.useParams();
  return <PaymentDetail caseId={caseId} />;
}

export const Route = createFileRoute("/payment/$caseId")({
  component: PaymentDetailPage,
});
